import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

export const Separator = styled.div`
  border-left: 1px solid
    ${({ color }) => (color ? getColor(color) : getColor('chambray'))};
  height: auto;
  align-self: stretch;
  ${({ pl }) =>
    pl
      ? `padding-left: ${pl}; margin-left: ${pl}`
      : 'margin-left: 4rem; padding-left: 5rem'};
  ${({ pr }) => (pr ? `padding-right: ${pr}; margin-right: ${pr}` : '')};
  ${({ space }) => (space ? `padding-left:${space}rem` : '')};
`;

export const SmallSeparator = styled(Separator)`
  height: 2rem;
  margin: auto;
`;
